import React from "react";
import styles from "./SkipToContent.module.css";

interface SkipToContentProps {
  id: string;
  skipToId: string;
}

const SkipToContent: React.FC<SkipToContentProps> = ({
  id = "SkipToContent",
  skipToId,
  ...rest
}): React.ReactElement => {
  const skipToContent = (e: any) => {
    if (e.key === "Enter" || e.button === 0 || e.button === 1) {
      e.preventDefault();
      const skipTo = document.getElementById(skipToId);
      if (skipTo) {
        skipTo.focus();
      } else {
        const skipToClass = document.getElementsByClassName(skipToId)[0] as HTMLElement;
        skipToClass && skipToClass.focus();
      }
      document.body.classList.remove("using-mouse");
      var skipButton = document.getElementById(id);
      skipButton && skipButton.blur();
    }
  };

  const dismissSTC = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === "Escape") {
      var skipButton = document.getElementById(id);
      skipButton && skipButton.blur();
    }
  };

  return (
    <div>
      <a
        className={styles["skip-main"]}
        id={id}
        aria-label="skip to content"
        tabIndex={0}
        onClick={(e) => {
          skipToContent(e);
        }}
        onKeyPress={(e) => {
          skipToContent(e);
        }}
        onKeyDown={(e) => {
          dismissSTC(e);
        }}
        {...rest}
      >
        Skip to main content
      </a>
    </div>
  );
};

export default SkipToContent;
